import React from "react"

import NotificationCard from "~components/shared/notification-card"
import COPY from "~config/copy-constants"

export default function PaymentFormNote() {
    return <NotificationCard>{COPY.CHECKOUT_PAYMENT_NOTE}</NotificationCard>
}
